import { createTheme } from "@mui/material/styles";
import { primary } from "./palette";

const paletteColors = {
  blue: { main: "#2196f3" },
  voilet: { main: "#9c27b0" },
  gray: { main: "#9e9e9e" },
  yellow: { main: "#78643E" },
  mintBlue: { main: "#80cbc4" },
  mintGreen: { main: "#00CD8C" }, // ✅ Added new color
};

// const primaryColorKey = localStorage.getItem("themeColor") || "blue";
const primaryColor = primary || paletteColors.blue;

export const getCustomTheme = (user) => {
  return createTheme({
    palette: {
      ...paletteColors,
      primary: primaryColor,
      success: {
        main: '#04b488',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    components: {
      MuiButton: {
        styleOverrides: {
          contained: {
            backgroundColor: primaryColor.main,
            color: "#fff",
            "&:hover": {
              backgroundColor: primaryColor.main,
              opacity: 0.9,
            },
          },
          outlined: {
            borderColor: primaryColor.main,
            color: primaryColor.main,
            "&:hover": {
              borderColor: primaryColor.main,
              backgroundColor: `${primaryColor.main}1A`,
            },
          },
          text: {
            color: primaryColor.main,
            "&:hover": {
              backgroundColor: `${primaryColor.main}1A`,
            },
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            minHeight: '500px',
            maxHeight: '500px',
            overflowY: 'auto',
                  transform: "scale(0.8)",
                  transformOrigin: "top left",
                  width: "calc(100% / 0.8)",
                  height: "calc(500px / 0.8)",
            "& .MuiDataGrid-columnHeader": {
              color: "#000",
              borderBottom: `2px solid ${primaryColor.main}`,
              fontWeight: 600,
              minHeight: 40,
              maxHeight: 40,
              height: 40,
              opacity: 0.9,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            },
            "& .MuiDataGrid-cell": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            },

            "& .MuiDataGrid-cell:focus": { outline: "none" },
            "& .MuiDataGrid-columnHeader:focus": { outline: "none" },
            "& .MuiDataGrid-columnHeader:focus-within": { outline: "none" },
            "& .Mui-selected": { backgroundColor: "transparent !important" },
            "& .MuiDataGrid-row:hover": { backgroundColor: "transparent" },
            "& .MuiDataGrid-sortIcon": {
              color: "#000",
            },
            "& .MuiDataGrid-iconButtonContainer": {
              color: "#000",
            },
          },
        },
      },
      MuiAutocomplete: {
      styleOverrides: {
        // Styles applied to the dropdown list items
        option: {
          fontSize: "13px",
          padding: "4px 8px",
        },
      },
      defaultProps: {
        ListboxProps: {
          style: {
            maxHeight: 200,
            overflowY: "auto",
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "13px",
          padding: "4px 8px",
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          maxHeight: 200,
        },
        list: {
          maxHeight: 200,
          overflowY: "auto",
        },
      },
    },
      MuiTextField: {
        defaultProps: {
          InputLabelProps: {
            shrink: true,
          },
        },
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              height: "30px",
            },
          },
        },
      },
      MuiSelect: {
        defaultProps: {
          displayEmpty: true,
        },
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              height: "30px",
              display: "flex",
              alignItems: "center",
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            textRendering: 'optimizeLegibility',
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          primary: {
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            textRendering: 'optimizeLegibility',
          },
        },
      },
      MuiLinearProgress: {
        styleOverrides: {
          colorSuccess: {
            backgroundColor: '#ccf5e1',
          },
          barColorSuccess: {
            backgroundColor: '#00C950',
          },
        },
      },
      MuiDateCalendar: {
        root: {
          width: 160,
          "& .MuiPaper-root": {
            width: 160, // only DatePicker calendar Paper
          },// matches overall width
        },
        styleOverrides: {
          root: {
            fontSize: "0.65rem",
            padding: 1,
            height: 230
          },
        },
      },
      MuiPickersCalendarHeader: {
        styleOverrides: {
          root: {
            minHeight: 30, // smaller header height
            padding: "0 2px",
            width: "160px"
          },
          label: {
            fontSize: "0.55rem", // smaller month/year text
          },
          labelContainer: {
            padding: 0,
          },
        },
      },
      MuiDayCalendar: {
        styleOverrides: {
          root: {
            width: 160, // matches overall width
          },
          weekDayLabel: {
            fontSize: "0.55rem", // smaller weekday letters
            width: 24,
            height: 24,
            margin: "1px 1px",
          },
        },
      },
      MuiYearCalendar: {
        styleOverrides: {
          root: {
            marginLeft: 50,
            width: 160, 
            display: 'block',
            padding: 5
          },}
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "0.65rem", // smaller date numbers
            width: 24,
            height: 24,
            margin: 0,
            },
          },
        },
        MuiPickersYear: {
              styleOverrides: {
                root: {
                  fontSize: "0.65rem", 
                  width: 24,
                  height: 24,
                  margin: 0,
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              "& .MuiDataGrid-root": {
                marginBottom: "2rem",
              },
            },
          },
        },
      MuiRadio: {
        defaultProps: {
        },
      },
      MuiCheckbox: {
        defaultProps: {
        },
      },
      MuiSwitch: {
        defaultProps: {
        },
      },
      MuiSlider: {
        defaultProps: {
        },
      },
    },
  });
};
